export default __webpack_public_path__ + "static/media/dz.67624652.svg";